var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLimits({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.26016 1.91997L6.13349 1.42664C3.52682 1.01997 2.32016 1.89997 1.90682 4.50664L1.41349 7.6333C1.14682 9.33997 1.42682 10.4466 2.39349 11.12C2.90016 11.48 3.59349 11.72 4.49349 11.86L7.62016 12.3533C10.2268 12.76 11.4335 11.88 11.8468 9.2733L12.3335 6.14664C12.4135 5.63331 12.4468 5.1733 12.4202 4.76664C12.3335 3.09997 11.3535 2.24664 9.26016 1.91997ZM5.49349 6.2333C4.71349 6.2333 4.08016 5.59997 4.08016 4.82664C4.08016 4.04664 4.71349 3.4133 5.49349 3.4133C6.26682 3.4133 6.90016 4.04664 6.90016 4.82664C6.90016 5.59997 6.26682 6.2333 5.49349 6.2333Z",
    fill: "#075FCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6669 8.98L12.6669 11.9867C11.8336 14.4933 10.5002 15.16 7.99355 14.3267L4.98689 13.3267C3.47355 12.8267 2.63355 12.1333 2.39355 11.12C2.90022 11.48 3.59355 11.72 4.49355 11.86L7.62022 12.3533C10.2269 12.76 11.4336 11.88 11.8469 9.27333L12.3336 6.14666C12.4136 5.63333 12.4469 5.17333 12.4202 4.76666C14.0136 5.61333 14.3602 6.89333 13.6669 8.98Z",
    fill: "#075FCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90008 4.82666C6.90008 5.6 6.26674 6.23333 5.49341 6.23333C4.71341 6.23333 4.08008 5.6 4.08008 4.82666C4.08008 4.04666 4.71341 3.41333 5.49341 3.41333C6.26674 3.41333 6.90008 4.04666 6.90008 4.82666Z",
    fill: "#075FCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimits);
export default __webpack_public_path__ + "static/media/limits.612b6775d70484b50472a1f22e350cc6.svg";
export { ForwardRef as ReactComponent };